import React, { useState, useContext } from 'react';
import Modal from 'react-modal';
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import { AlertContext } from '../../context/AlertContext';

const ModalUpdatePassword = ({
    isOpen,
    onClose,
    userSelected,
    server,
    languaje,
    isUserProtected
}) => {
    const { handleShowPopup } = useContext(AlertContext);

    const [adminNewPassword, setAdminNewPassword] = useState("");
    const [passMessage, setPassMessage] = useState("");
    const [loading, setLoading] = useState(false);


    const handleAdminChangePassword = async () => {
        if (adminNewPassword.length < 5) {
            setPassMessage("Mínimo 5 caracteres");
            return;
        }

        if (isUserProtected(userSelected.mail)) {
            handleShowPopup('Error', 'Este usuario está protegido por el sistema', '', false);
            return;
        }

        setLoading(true);
        try {
            const resp = await fetch(`${server.url}/api/v1/auth/admin-change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("access_token")}`
                },
                body: JSON.stringify({
                    user_id: userSelected.user_id,
                    new_password: adminNewPassword
                })
            });

            if (resp.ok) {
                handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), 'Contraseña actualizada con éxito', '', true);
                setAdminNewPassword("");
                onClose();
            } else {
                const err = await resp.json();
                handleShowPopup('Error', err.message || "Error al actualizar", '', false);
            }
        } catch (e) {
            handleShowPopup('Error', "Error de conexión", '', false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => {
                setAdminNewPassword("");
                setPassMessage("");
                onClose();
            }}
            style={{
                content: {
                    top: "50%", left: "50%", right: "auto", bottom: "auto",
                    marginRight: "-50%", transform: "translate(-50%, -50%)",
                    width: "40%", height: "40%", padding: "20px", background: "#ffffff"
                },
            }}
        >
            <div className="modal-GS-content">
                <div className='card-modal-gs modal-verificate' style={{ width: '100%' }}>
                    <div className='head-card-modal-gs'>
                        <div className='title-head-card-modal-gs'>ACTUALIZAR CONTRASEÑA</div>
                    </div>
                    <div className='content-card-modal-gs'>
                        <div className="form-GS-box">
                            <div className="user-box-GS" style={{ height: '20%', marginTop: '20px', marginBottom: '20px' }}>
                                <p style={{ color: 'var(--txt-color)', fontSize: '14px', margin: '0' }}>
                                    Usuario: <span style={{ color: '#15243E' }}>{userSelected?.mail}</span>
                                </p>
                            </div>
                            <div className="user-box-GS" style={{ height: '25%' }}>
                                <input
                                    required
                                    type="password"
                                    autoComplete="off"
                                    value={adminNewPassword}
                                    onChange={(e) => {
                                        setAdminNewPassword(e.target.value);
                                        setPassMessage(e.target.value.length > 0 && e.target.value.length < 5 ? "Mínimo 5 caracteres" : "");
                                    }}
                                    onKeyDown={(e) => e.key === 'Enter' && handleAdminChangePassword()}
                                />
                                <label className='label-GS'>Nueva contraseña</label>
                                {passMessage && <span style={{ color: '#ff4d4d', fontSize: '11px', position: 'absolute', bottom: '-15px', left: '0' }}>{passMessage}</span>}
                            </div>
                            <div className="user-box-admin" style={{ height: '20%', marginTop: '20px' }}>
                                {loading ? <LoadSimple /> : (
                                    <>
                                        <Action origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={onClose} />
                                        <Action disabled={adminNewPassword.length < 5} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={handleAdminChangePassword} />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ModalUpdatePassword;